var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page min-h-screen"},[_c('Navbar'),_c('main',[_c('HeroSection'),_c('ServicesSection'),_c('SectorsSection'),_c('ContactSection')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }